export default Object.freeze({
  ERROR_MESSAGES: {
    CANNOT_EDIT_USER_PENDING_REVIEW: 'Cannot edit user pending review!',
  },
});
